import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'bd-resources-select-inline-loading',
  template: `
    <div>
      <p-skeleton [height]="'56px'"></p-skeleton>
    </div>
    <div>
      <p-skeleton [height]="'2px'"></p-skeleton>
    </div>
  `,
  styles: [],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SkeletonModule],
})
export class BdResourcesSelectInlineLoadingComponent {}
